import { Component, input, signal } from "@angular/core";
import { Field, FormField } from "@angular/forms/signals";

@Component({
  selector: "app-password-input",
  imports: [FormField],
  templateUrl: "./password-input.html",
  styleUrl: "./password-input.scss"
})
export class PasswordInput {
  readonly formField = input.required<Field<string>>();
  readonly id = input("");
  readonly placeholder = input("");

  readonly visible = signal(false);

  toggleVisibility(): void {
    this.visible.update((value) => !value);
  }
}
